import { AnyAction } from 'redux';
import UserService from '../../../services/user';
import { parseApiError } from '../../../commons/error';
import { notification } from 'antd';
import { Pageable, User, Permission, Customer } from '../../../types/type';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { initUser, initCustomer } from 'commons/initTypes';
import { isEmpty } from 'lodash';
import CustomerService from 'services/customers';

const userService = new UserService();
const customerService = new CustomerService();

type ITA = ThunkAction<Promise<void>, unknown, unknown, AnyAction>;
type IDA = ThunkDispatch<unknown, unknown, AnyAction>;

export interface SetAction {
  type: 'SET';
  usersList: Partial<Pageable>;
}
export interface SetPermissionAction {
  type: 'SET_PERMISSION';
  permissionList: Permission[];
}
export interface SetCustomerAction {
  type: 'SET_CUSTOMER';
  customer: Customer;
}
export interface SaveAction {
  type: 'SAVE';
  usersaved: User;
}
export interface UpdateAction {
  type: 'UPDATE';
  userupdate: unknown;
}

export type Action = SetAction;

export const set = (usersList: Partial<Pageable>): SetAction => {
  return { type: 'SET', usersList };
};
export const setPermission = (
  permissionList: Permission[],
): SetPermissionAction => {
  return { type: 'SET_PERMISSION', permissionList };
};
export const setCustomer = (customer: Customer): SetCustomerAction => {
  return { type: 'SET_CUSTOMER', customer };
};

export const usersSave = (usersaved: User): SaveAction => {
  return { type: 'SAVE', usersaved };
};
export const updateUser = (userupdate: unknown): UpdateAction => {
  return { type: 'UPDATE', userupdate };
};
export const cleanRedux = (): ITA => {
  return async (dispatch: IDA): Promise<void> => {
    try {
      dispatch(setPermission([]));
      dispatch(set({}));
      dispatch(usersSave(initUser));
      dispatch(updateUser({}));
      dispatch(setCustomer(initCustomer));
    } catch (err) {
      notification.error(parseApiError(err));
    }
  };
};

export const getPermissions = (): ITA => {
  return async (dispatch: IDA): Promise<void> => {
    try {
      const permissionResponse = await userService.permissionList();
      dispatch(setPermission(permissionResponse));
    } catch (err) {
      notification.error(parseApiError(err));
    }
  };
};

export const getCustomer = (code: string): ITA => {
  return async (dispatch: IDA): Promise<void> => {
    try {
      const customerResponse = await customerService.getCustomerG4S(code);
      dispatch(setCustomer(customerResponse));
    } catch (err) {
      notification.error(parseApiError(err));
    }
  };
};

export const page = (page: number, search = ''): ITA => {
  return async (dispatch: IDA): Promise<void> => {
    try {
      const responsepage = await userService.usersList(page, search);
      const permissionResponse = await userService.permissionList();
      dispatch(setPermission(permissionResponse));
      dispatch(set(responsepage));
    } catch (err) {
      notification.error(parseApiError(err));
    }
  };
};

export const getUserAction = (userId: string): ITA => {
  return async (dispatch: IDA): Promise<void> => {
    try {
      const response = await userService.getUser(userId);
      dispatch(usersSave(response));
    } catch (error) {
      notification.error(parseApiError(error));
    }
  };
};

export const saveuser = (user: User, getUserList = true): ITA => {
  return async (dispatch: IDA): Promise<void> => {
    try {
      const responseuser = await userService.save(user);
      dispatch(usersSave(responseuser));
      let succesMessage =
        'Usuario registrado exitósamente, revisa tu correo para activar tu cuenta.';
      if (!isEmpty(user.id)) succesMessage = 'Usuario modificado exitósamente.';
      notification.success({
        description: succesMessage,
        duration: 3,
        message: 'Éxito',
      });

      if (getUserList) {
        const responsepage = await userService.usersList(1);
        dispatch(set(responsepage));
      }
    } catch (err) {
      notification.error(parseApiError(err));
    }
  };
};
export const activateUserById = (active: string): ITA => {
  return async (dispatch: IDA): Promise<void> => {
    try {
      const responseuser: Pageable = await userService.activateUserById(active);
      dispatch(updateUser(responseuser));
    } catch (err) {
      notification.error(parseApiError(err));
    }
  };
};
export const desactivateUserById = (desactive: string): ITA => {
  return async (dispatch: IDA): Promise<void> => {
    try {
      const responseuser = await userService.deactivateUserById(desactive);
      dispatch(updateUser(responseuser));
    } catch (err) {
      notification.error(parseApiError(err));
    }
  };
};

export const trysendpassword = (userEmail: string): ITA => {
  return async (): Promise<void> => {
    try {
      await userService.trysendpassword(userEmail);
      notification.success({
        description: 'Correo Enviado Exitosamente',
        duration: 3,
        message: 'Éxito',
      });
    } catch (err) {
      notification.error(parseApiError(err));
    }
  };
};

export const passwordrecovery = (userEmail: string): ITA => {
  return async (): Promise<void> => {
    try {
      await userService.passwordrecovery(userEmail);
      await notification.success({
        description: 'Correo Enviado Exitosamente',
        duration: 3,
        message: 'Éxito',
      });
      setTimeout(() => (window.location.href = '/login'), 3500);
    } catch (err) {
      notification.error(parseApiError(err));
    }
  };
};
